import { observer } from "mobx-react";
import Card from "../../../../components/layouts/card/card";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import BookSessionButton from "./components/book-session-button/book-session-button";
import currentPortalStore from "../../../../stores/current-portal-store";
import HelpVideosButton from "./components/help-videos-button/help-videos-button";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./need-help-card.scss";
import ContactUsButtons from "./components/contact-us-buttons/contact-us-buttons";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../dashboard-translation/stores/dashboard-translations-store";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";

const NeedHelpCard: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const isMerchantOnboarded = !!currentPortalStore.setting?.isMerchantOnboarded;
    const isLoading = currentPortalStore.isLoading || dashboardTranslationsStore.isLoading;

    return (
		<ResolveCapability capability={PROFILE_CAPABILITIES.SUPPORT}>
			{({ showHelpSection }) => showHelpSection && (
				<Card isLoading={isLoading}>
					<FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>{getTranslation('NEED_HELP_TITLE', 'dashboard-home')}</FontHeading2>
					<div className={`need-help-content ${isMerchantOnboarded ? 'onboarding-completed' : ''}`}>
						{!isLoading && (
							<>
								{!isMerchantOnboarded && (
									<BookSessionButton />
								)}
								<ContactUsButtons />
								<HelpVideosButton />
							</>
						)}
					</div>
				</Card>
			)}
		</ResolveCapability>
    );
});

export default NeedHelpCard;
